import { capitalize as s, generateUtilityClass as l } from "@mui/material";
import c from "@mui/utils/composeClasses";
function a(t) {
  return l("TrueSvgIcon", t);
}
const p = (t) => {
  const { color: o, fontSize: e, classes: i } = t, r = `${e}`, n = {
    root: [
      "root",
      o !== "inherit" && `color${s(o)}`,
      `fontSize${s(r)}`
    ]
  };
  return c(n, a, i);
};
export {
  a as getUtilityClass,
  p as useUtilityClasses
};
//# sourceMappingURL=svg-icon.classes.js.map
